import { render, staticRenderFns } from "./fourlists.vue?vue&type=template&id=3ff192dc&scoped=true"
import script from "./fourlists.vue?vue&type=script&lang=js"
export * from "./fourlists.vue?vue&type=script&lang=js"
import style0 from "./fourlists.vue?vue&type=style&index=0&id=3ff192dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff192dc",
  null
  
)

export default component.exports